import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

const NotFoundDialog = ({ open, onClose }) => (
  <Dialog
    open={open}
    onClose={onClose}
    PaperProps={{
      sx: { borderRadius: 3, direction: "ltr", minWidth: 300, maxWidth: 400 },
    }}
  >
    <DialogTitle
      sx={{
        fontWeight: 700,
        fontSize: "1.05rem",
        pb: 1,
        display: "flex",
        alignItems: "center",
        gap: 1,
        color: "#d32f2f",
      }}
    >
      <WarningAmberIcon sx={{ fontSize: 28 }} />
      קוד QR לא נמצא
    </DialogTitle>
    <DialogContent>
      <Typography sx={{ fontSize: "0.95rem", color: "#555", lineHeight: 1.6 }}>
        המכשיר עם קוד QR זה לא נמצא במערכת Priority.
        <br />
        <br />
        אנא ודא שהמכשיר נרשם במערכת או פנה לתמיכה.
      </Typography>
    </DialogContent>
    <DialogActions sx={{ px: 2, pb: 2 }}>
      <Button
        variant="contained"
        onClick={onClose}
        sx={{
          flex: 1,
          borderRadius: 2,
          fontWeight: 600,
          bgcolor: "#d32f2f",
          "&:hover": { bgcolor: "#b71c1c" },
        }}
      >
        הבנתי
      </Button>
    </DialogActions>
  </Dialog>
);

export default NotFoundDialog;
